@if (uiFieldSpec.facadeDescription) {
    <div class="field"><p>{{uiFieldSpec.facadeDescription}}</p></div>
}
@if (uiFieldSpec.lpl) {
    <lm-lpl-editor #LplEditor
                   [lpl]="uiFieldSpec.lpl"
                   [readonly]="true"
    ></lm-lpl-editor>
}
